module.exports = __webpack_public_path__ + "images/directory/power-ups-banner-v2.260b9c5f78bd43739ef9.png";